import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-profile',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {
  activeTab = 'profile';
  user: any = {};
  passwordData = {
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  };
  profileMessage: { text: string; type: 'success' | 'error' } | null = null;
  passwordMessage: { text: string; type: 'success' | 'error' } | null = null;

  constructor(private http: HttpClient) {}

  ngOnInit() {
    this.loadUserProfile();
  }

  setActiveTab(tab: string) {
    this.activeTab = tab;
    this.profileMessage = null;
    this.passwordMessage = null;
  }

  loadUserProfile() {
    this.http.get(`/api/users/profile`)
      .subscribe({
        next: (data) => {
          this.user = data;
        },
        error: (error) => {
          console.error('Profil yüklenirken hata:', error);
        }
      });
  }

  updateProfile() {
    this.http.put(`/api/users/profile`, this.user)
      .subscribe({
        next: () => {
          this.profileMessage = { text: 'Profil başarıyla güncellendi', type: 'success' };
        },
        error: (error) => {
          console.error('Profil güncellenirken hata:', error);
          this.profileMessage = { text: 'Profil güncellenirken bir hata oluştu', type: 'error' };
        }
      });
  }

  changePassword() {
    if (this.passwordData.newPassword !== this.passwordData.confirmPassword) {
      this.passwordMessage = { text: 'Yeni şifreler eşleşmiyor', type: 'error' };
      return;
    }

    this.http.post(`/api/users/change-password`, this.passwordData)
      .subscribe({
        next: () => {
          this.passwordMessage = { text: 'Şifre başarıyla değiştirildi', type: 'success' };
          this.passwordData = {
            currentPassword: '',
            newPassword: '',
            confirmPassword: ''
          };
        },
        error: (error) => {
          console.error('Şifre değiştirilirken hata:', error);
          this.passwordMessage = { text: 'Şifre değiştirilirken bir hata oluştu', type: 'error' };
        }
      });
  }
} 